// SPDX-License-Identifier: MPL-2.0

export const ja = {
  // App
  'app.title': 'かぐや',
  'app.tagline': 'かぐや — やさしい Misskey クライアント',
  'app.subtitle': 'やさしくて、しんぷるな Misskey クライアント',

  // Navigation
  'nav.home': 'ホーム',
  'nav.inbox': '受信箱',
  'nav.notifications': '通知',
  'nav.settings': '設定',
  'nav.back': '戻る',
  'nav.side_navigation': 'サイドナビゲーション',
  'nav.bottom_navigation': 'ボトムナビゲーション',

  // Common actions
  'action.close': '閉じる',
  'action.cancel': 'キャンセル',
  'action.remove': '削除',
  'action.back': '戻る',
  'action.copy': 'コピー',
  'action.retry': 'もう一度試す',
  'action.refresh': '更新',
  'action.refresh_cooldown': 'あと{s}秒で更新できます',
  'action.load_more': 'もっと読み込む',

  // Theme
  'theme.switch_to_light': 'ライトモードに切り替え',
  'theme.switch_to_dark': 'ダークモードに切り替え',
  'theme.system': 'システム',
  'theme.light': 'ライト',
  'theme.dark': 'ダーク',

  // Quiet mode
  'quiet_mode.on': 'おやすみモード',
  'quiet_mode.off': 'おやすみモード解除',
  'quiet_mode.status': 'おやすみ中',
  'quiet_mode.manual_active': 'おやすみモード中 — ストリーミングを一時停止しています',
  'quiet_mode.hours_active': 'おやすみ時間中です',
  'quiet_mode.resume': '再開',

  // Compose
  'compose.title': 'ノートを書く',
  'compose.placeholder': '今何してる？',
  'compose.cw_placeholder': '閲覧注意（CW）の注釈',
  'compose.cw_button': '閲覧注意 (CW)',
  'compose.attach_image': '画像を添付',
  'compose.attachment_alt': '添付画像',
  'compose.alt_placeholder': '画像の説明(見えない人のために)。hackers.pub では空なら自動で作ります',
  'compose.alt_required': '画像の説明を作れませんでした。書いてから送ってください',
  'compose.visibility': '公開範囲',
  'compose.language': '言語',
  'compose.language_auto': '自動 ({lang})',
  'compose.visibility_public': 'パブリック',
  'compose.visibility_home': 'ホームのみ',
  'compose.visibility_followers': 'フォロワー限定',
  'compose.visibility_specified': 'ダイレクト',

  // Timeline
  'timeline.filtered': 'フィルター',
  'timeline.filtered_active': 'フィルター中',
  'compose.sending': '送信中...',
  'compose.submit': 'ノート',
  'compose.posted': '投稿しました',
  'compose.reply_placeholder': '返信を書き込む...',

  // Note
  'note.collapse_cw': 'たたむ',
  'note.reveal_cw': 'みる',
  'note.reply': '返信',
  'note.renote': 'リノート',
  'note.reaction': 'リアクション',
  'note.add_reaction': 'リアクションを追加',
  'note.more': 'その他',
  'note.open_original': '元の投稿を開く',
  'note.copy_link': 'リンクをコピー',
  'note.link_copied': 'リンクをコピーしました',
  'note.copy_failed': 'コピーできませんでした',
  'note.from_user': 'のノート',
  'note.user_renoted': 'がリノート',
  'note.section_replies': '返信',

  // Note errors
  'note.renoted': 'リノートしました',
  'note.renote_failed': 'リノートできませんでした',
  'note.reaction_failed': 'リアクションできませんでした',
  'note.post_failed': '投稿できませんでした',
  'note.image_upload_failed': '画像のアップロードに失敗しました',
  'note.favorite': 'お気に入り',
  'note.unfavorite': 'お気に入り解除',
  'note.favorited': 'お気に入りに追加しました',
  'note.unfavorited': 'お気に入りから削除しました',
  'note.favorite_failed': 'お気に入りに追加できませんでした',

  // Image
  'image.sensitive_aria': '閲覧注意の画像、タップで表示',
  'image.enlarge': '画像を拡大',
  'image.show_sensitive': '閲覧注意のコンテンツを表示',
  'image.sensitive_label': '閲覧注意',
  'image.tap_to_show': 'タップで表示',
  'image.viewer': '画像ビューア',
  'image.close_viewer': '画像ビューアを閉じる',

  // Timeline
  'timeline.home': 'ホーム',
  'timeline.local': 'ローカル',
  'timeline.global': 'グローバル',
  'timeline.hybrid': 'ソーシャル',
  'timeline.antenna': 'アンテナ',
  'timeline.list': 'リスト',
  'timeline.channel': 'チャンネル',
  'timeline.feed': 'フィード',
  'timeline.streaming': '配信中',
  'timeline.loading': '読み込み中...',
  'timeline.no_notes': 'ノートはまだありません',
  'timeline.filter_no_rules': 'このタイムラインはリアクション数でローカルノートを絞り込みます。',
  'timeline.filter_no_rules_hint': '設定 → フィルタータイムライン からルールを追加してください。',
  'timeline.filter_hides_all': '現在フィルター条件に合うノートはありません。',
  'timeline.user_filter_hides_all': '取得したノートはすべてユーザーフィルターで非表示になっています。',
  'timeline.no_more': 'これ以上ありません',
  'timeline.load_failed': 'うまく読み込めませんでした',
  'timeline.reconnecting': 'つながりを待っています…',
  'timeline.load_failed_retry': 'うまく読み込めませんでした。もう一度お試しください',
  'timeline.caught_up': 'ここまで読みました',
  'timeline.new_notes': '件の新しいノート',
  'timeline.show_new': '表示する',
  'timeline.details': '詳細',
  'timeline.what_went_wrong': '何が起きたか詳しく見る',

  // Notifications
  'notifications.title': '通知',
  'notifications.empty': '通知はまだありません',
  'notifications.close': '通知を閉じる',
  'notifications.mark_all_read': 'すべて既読にする',

  // Emoji
  'emoji.picker': '絵文字ピッカー',
  'emoji.search_placeholder': '絵文字を検索...',
  'emoji.search': '絵文字を検索',
  'emoji.close_picker': '絵文字ピッカーを閉じる',
  'emoji.all': 'すべて',
  'emoji.not_found': '絵文字が見つかりません',
  'emoji.list': '絵文字一覧',
  'emoji.select': 'を選択',

  // Account
  'account.menu': 'アカウントメニュー',
  'account.remove': 'アカウントを削除',
  'account.add': 'アカウントを追加',
  'account.logout': 'ログアウト',
  'account.invalid_tokens': 'トークンが無効なアカウント',

  // Settings
  'settings.title': '設定',
  'settings.section_account': 'アカウント',
  'settings.section_notifications': '通知',
  'settings.push_notifications': 'プッシュ通知',
  'settings.section_posting': '投稿',
  'settings.section_filtered_timeline': 'フィルタータイムライン',
  'settings.filtered_timeline_description': '「フィルター」ローカルタイムラインは、以下のルールにすべて一致するノートのみ表示します。リアクション名は部分一致（例：「kawaii」は :kawaii@.: にマッチ）。',
  'settings.filter_logic': 'ルールの結合',
  'settings.filter_emoji': 'リアクション名',
  'settings.filter_emoji_placeholder': '例: kawaii',
  'settings.filter_operator': '演算子',
  'settings.filter_threshold': '件数',
  'settings.filter_add_rule': 'ルールを追加',
  'settings.filter_no_rules': 'ルールなし — ローカルのすべてのノートが表示されます。',
  'settings.default_note_visibility': 'ノートのデフォルト公開範囲',
  'settings.default_renote_visibility': 'リノートのデフォルト公開範囲',
  'settings.section_display': '表示',
  'settings.font_size': '文字サイズ',
  'settings.font_small': '小',
  'settings.font_medium': '中',
  'settings.font_large': '大',
  'settings.reduce_motion': 'アニメーションを減らす',
  'settings.streaming': 'ライブストリーミング',
  'settings.streaming_description': '新しいノートが届くたびにタイムラインを自動更新します。落ち着いた体験のため、初期状態ではオフです。',
  'settings.section_quiet': 'おやすみモード',
  'settings.quiet_manual': '今すぐおやすみモードにする',
  'settings.quiet_manual_description': 'ストリーミングを停止し、ライブ表示を落ち着かせ、新しいノートを一時的に保留します。',
  'settings.quiet_hours': 'おやすみ時間',
  'settings.quiet_hours_description': '指定した時間帯は自動でおやすみモードになります。',
  'settings.quiet_hours_range': '時間帯',
  'settings.quiet_hours_start': '開始時刻',
  'settings.quiet_hours_end': '終了時刻',
  'settings.media_proxy': 'メディアプロキシ（プライバシー保護）',
  'settings.media_proxy_description': '画像や絵文字をインスタンスのプロキシ経由で読み込み、IPアドレスの漏洩を防ぎます。',
  'settings.hide_nsfw': 'NSFWコンテンツを非表示',
  'settings.hide_nsfw_description': '閲覧注意（CW）やセンシティブな画像を含むノートをタイムラインから非表示にします。',
  'settings.section_theme': 'テーマ',
  'settings.section_language': '言語',
  'settings.section_cache': 'キャッシュ',
  'settings.cache_emoji': '絵文字キャッシュ',
  'settings.cache_emoji_description': 'インスタンスのカスタム絵文字をすべてダウンロードしてキャッシュします。通常、絵文字は表示時に読み込まれます。',
  'settings.cache_emoji_btn': '絵文字をキャッシュする',
  'settings.cache_emoji_loading': 'キャッシュ中...',
  'settings.cache_emoji_done': 'キャッシュ済み',
  'settings.section_data': 'データ',
  'settings.clear_all_data': 'すべてのデータを削除',
  'settings.clear_all_confirm': 'すべてのデータを削除しますか？\nアカウント情報や設定がすべて消去されます。この操作は取り消せません。',
  'settings.reset_app': 'キャッシュを削除',
  'settings.reset_app_description': 'うまく動かないときに。古い Service Worker と cache を消して読み込み直します。JavaScript が壊れていても動きます。',
  'settings.section_about': 'このアプリについて',
  'settings.about_privacy': 'このアプリはアナリティクスやトラッキングを一切使用していません。アカウント情報や設定はすべてこのブラウザの localStorage にのみ保存され、外部サーバーに送信されることはありません。',

  // Login
  'login.instance': 'インスタンス',
  'login.instance_placeholder': 'misskey.io',
  'login.access_token': 'アクセストークン',
  'login.permission_mode': '権限モード',
  'login.permission_standard': '標準（読み書き）',
  'login.permission_readonly': '読み取り専用',
  'login.permission_details_summary': '権限について詳しく',
  'login.permission_standard_detail': '標準（読み書き）：ノートの投稿、リアクション、フォローなどすべての操作ができます。',
  'login.permission_readonly_detail': '読み取り専用：タイムラインの閲覧のみ。誤操作の心配がありません。',
  'login.token_privacy': 'トークンはこのブラウザにのみ保存され、外部に送信されることはありません。',
  'login.connecting': '接続中...',
  'login.login_with_token': 'トークンで接続',
  'login.login_with_miauth': 'MiAuth でログイン',
  'login.login_with_oauth2': 'OAuth2 でログイン',
  'login.help_miauth': 'インスタンスに移動して認証します。トークンを手動で作成する必要はありません。',
  'login.help_token': 'インスタンスの 設定 → API からアクセストークンを取得してください。',
  'login.help_oauth2': 'OAuth2 で安全に認証します。インスタンスが OAuth2 に対応していない場合は MiAuth をお試しください。',
  'login.help_mastodon': 'OAuth2 で安全に認証します。',
  'login.help_hackerspub': 'hackers.pub はメールでサインインします。ユーザー名（またはメール）を入れて、届いたコードを入力してください。',
  'login.hp_username': 'ユーザー名',
  'login.hp_email': 'メールアドレス',
  'login.hp_use_username': 'ユーザー名',
  'login.hp_use_email': 'メール',
  'login.hp_send_code': 'コードを送る',
  'login.hp_code': 'サインインコード',
  'login.hp_code_sent': 'サインインコードをメールで送りました。ここに入力してください。',
  'login.hp_verify': '確認',
  'login.hp_back': '別のアカウントにする',
  'login.hp_link_sent': 'メールを送りました。届いたリンクを押すとサインインできます。',
  'login.hp_enter_code': 'コードを入力する',
  'login.login_with_bluesky': 'Bluesky でログイン',
  'login.help_bluesky': 'Bluesky のハンドルを入力してください。認証ページにリダイレクトされます。',
  'login.bluesky_handle': 'Bluesky ハンドル',
  'login.validating': '読み込み中...',

  // Auth errors
  'error.invalid_credentials': 'ログインできませんでした。インスタンスURLやトークンをご確認ください。',
  'error.network': 'サーバーに接続できませんでした。インスタンスURLやネットワーク環境をご確認ください。',
  'error.unknown': 'うまくいきませんでした。しばらくしてからもう一度お試しください。',
  'error.not_connected': 'サーバーに接続できていないようです',
  'readonly.explanation': '閲覧専用トークンで接続中のため、投稿・リアクション・フォローはできません。',
  'error.post_failed': '投稿できませんでした',

  // Auth callback
  'auth.checking': '認証確認中...',
  'auth.login_success': 'ログイン成功！',
  'auth.redirecting_home': 'ホームへ移動中...',
  'auth.failed': '認証に失敗しました。',
  'auth.error_details': 'エラー詳細',
  'auth.back_to_login': 'ログインページへ戻る',
  'auth.hp_other_browser': 'このリンクは、サインインを始めたブラウザとは別のブラウザで開かれたようです。',
  'auth.hp_sign_in_here': 'このブラウザでサインイン',
  'auth.hp_copy_code': 'コードをコピー',
  'auth.hp_copied': 'コピーしました',
  'auth.hp_copy_hint': 'コピーしたコードを、サインインを始めたブラウザの「コードを入力する」に貼り付けてください。',
  'auth.logging_in': 'ログイン中...',
  'auth.session_expired': 'セッションが期限切れか見つかりません。',
  'auth.redirecting_login': 'ログインページへ移動中...',

  // User page
  'user.decode_failed': 'ユーザー情報の解析に失敗しました',
  'user.stat_notes': 'ノート',
  'user.stat_following': 'フォロー',
  'user.stat_followers': 'フォロワー',
  'user.pinned_notes': 'ピン留め',
  'user.section_notes': 'ノート',
  'user.no_notes': 'ノートはまだありません',
  'user.no_more': 'これ以上ありません',
  'user.follow': 'フォロー',
  'user.unfollow': 'フォロー解除',
  'user.follow_failed': 'フォローできませんでした',
  'user.unfollow_failed': 'フォロー解除できませんでした',
  'user.followed': 'フォローしました',
  'user.unfollowed': 'フォロー解除しました',
  'user.bot_badge': 'Bot',

  // Poll
  'poll.votes': '票',
  'poll.expired': '投票終了',
  'poll.expires_at': '締め切り',
  'poll.vote_failed': '投票できませんでした',
  'poll.voted': '投票しました',
  'poll.label': '投票',

  // Note page
  'note_page.remote_fetch_failed': 'リモートノートの取得に失敗しました',
  'note_page.remote_resolve_failed': 'リモートURIがノートとして解決できませんでした',
  'note_page.decode_failed': 'ノートの解析に失敗しました',
  'note_page.remote_warning': 'このノートは連合先から取得されたコピーです。元のノートより情報が不完全な場合があります。',
  'note_page.view_original': '元のノートを見る →',

  // Push notifications
  'push.unsupported': 'プッシュ通知未対応',
  'push.permission_denied': '通知が拒否されています',
  'push.generating': 'スクリプト生成中...',
  'push.disable': 'プッシュ通知を無効にする',
  'push.reload_retry': 'ページを再読み込みして再試行',
  'push.enable': 'プッシュ通知を有効にする',
  'push.script_instructions': '以下のAiScriptをMisskeyのスクラッチパッドで実行してください：',
  'push.open_scratchpad': 'スクラッチパッドを開く',
  'push.executed': '実行しました',
  'push.migrated': 'プッシュ通知はネイティブMisskey方式に移行しました。設定から有効にしてください。',
  'push.back_to_settings': '← 設定へ',

  // App state
  'app.new_version': '新しいバージョンが利用可能です',
  'app.update_now': '今すぐ更新',
  'app.select_note': 'ノートを選択してください',
  'app.loading': '読み込み中...',

  // Image gallery
  'image.gallery_single': '画像',
  'image.gallery_count': '枚の画像',

  // MFM
  'mfm.search_button': '検索',

  // User filter
  'user_filter.button': 'ユーザーフィルター',
  'user_filter.images_only': '画像のみ表示',
  'user_filter.no_renotes': 'リノートを非表示',

  // Inbox
  'inbox.title': '受信箱',
  'inbox.empty': '受信箱は空です',
  'inbox.clear_all': 'すべて消去',
  'inbox.dismiss_group': '消去',
  'inbox.see_all': 'すべての通知を見る',
  'inbox.group_direct': 'メンション・返信',
  'inbox.group_quotes': '引用',
  'inbox.group_renotes': 'リノート',
  'inbox.group_reactions': 'リアクション',
  'inbox.group_follows': 'フォロー',
  'inbox.group_other': 'その他',
  'inbox.group_home': 'ホームタイムライン',
  'inbox.go_home': 'ホームへ',
  'inbox.view_thread': 'スレッドを見る',
  'inbox.mark_read': '既読にする',

  // Timeline Inbox
  'timeline_inbox.title': 'タイムライン受信箱',

  // Generic
  'generic.error_prefix': 'エラー',

  // Interpolated — `{n}`, `{handle}`, `{name}` placeholders are
  // substituted by t(key, params). Lift the corresponding hardcoded
  // strings via i18n.ts's t() interpolation.
  'image.show_more_files': 'もっと表示 ({n} 件)',
  'aria.mention_to': 'メンション: {handle}',
  'aria.emoji_name': '{name} 絵文字',
} as const satisfies Record<string, string>

export type I18nKey = keyof typeof ja
